module.exports = __webpack_public_path__ + "static/media/fexibill_digitalis_faktoring_feher.cbbd5736.svg";